



































































import { computed, defineComponent, getCurrentInstance, nextTick, reactive, ref, watch } from '@vue/composition-api';
import { CloseIcon, CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import qrcodeHandler, { QRCodeStatus } from './qrcodeHandler';

export default defineComponent({
  name: 'ESignDialog',
  components: {
    CloseIcon,
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    wpsResult: Object || null,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const approveData = reactive({
      showPopup: false,
      approved: false,
    });
    const { loading: qrcodeLoading, qrcodeStatus, keyData, methods: qrcodeMethods } = qrcodeHandler();
    const qrcodeRender = computed(() => {
      const isSuccess = [QRCodeStatus.FINISHED, QRCodeStatus.CONFIRMED].includes(qrcodeStatus.value);
      const isError = QRCodeStatus.ERROR === qrcodeStatus.value;
      const isExpired = QRCodeStatus.EXPIRED === qrcodeStatus.value;
      // FIX: 不需要授权停在扫码完成状态
      const isScanned = [QRCodeStatus.SCANNED, QRCodeStatus.CODERETURNED].includes(qrcodeStatus.value);
      const needAuth = QRCodeStatus.NEEDTOCONFIRM === qrcodeStatus.value;
      return {
        showQRCode: !needAuth,
        showMask: isScanned || isSuccess || isError || isExpired,
        showScanned: isScanned,
        showRefresh: isError || isExpired,
        showSuccess: isSuccess,
        showAuth: needAuth,
      };
    });
    const methods = {
      onClose() {
        innerShow.value = false;
      },
      // 打开服务协议
      openAgreementPage(urlType: 'serviceAgreement' | 'privacyAgreement') {
        if (urlType === 'serviceAgreement') {
          dispatchRouter(CONSTANT_URL.serviceAgreement);
        } else if (urlType === 'privacyAgreement') {
          dispatchRouter(CONSTANT_URL.privacyAgreement);
        }
      },
      confirmEsignAuth() {
        if (approveData.approved) {
          qrcodeMethods.confirmEsignAuth();
        } else {
          approveData.showPopup = true;
        }
      },
      onClickApprovePopupOutside() {
        approveData.showPopup = false;
      },
      refreshQRCode() {
        qrcodeMethods.getQRCodeUrl(props.wpsResult);
      },
    };
    watch(innerShow, val => {
      if (val) {
        qrcodeMethods.startWSListener();
        qrcodeMethods.getQRCodeUrl(props.wpsResult);
        approveData.approved = false;
      } else {
        qrcodeMethods.resetESignData({
          resetKey: true,
        });
      }
    });
    return {
      innerShow,
      keyData,
      qrcodeLoading,
      qrcodeStatus,
      qrcodeRender,
      qrcodeMethods,
      approveData,
      ...methods,
    };
  },
});
